<nav class="navbar fixed-top" style="border-bottom:solid 1px var(--welarasand)">
  <div class="container-fluid">
    <div style="width:33%">
      <span id="sidebar_toggle" [hidden]="isSidebarOpen" (click)="toggleSidebar()" class="btn_sidebar c_sand me-2"
        title="Show Sidebar">
        <i class="fas fa-fw fa-chevron-right"></i>
      </span>
      <img src="assets/welara_word.png" alt="Welara" style="width:160px;height:33px" class="mt-1" />
    </div>
    <div style="width:34%;height:38px;line-height:38px" class="text-center">
      <input type="text" class="form-control form-control-sm global_search" placeholder="Search WelaraOS" />
      

    </div>

    <div style="width:33%" class="text-end">
      <span id="msg_center_info" (click)="gotoMsgCenter()" class="d-none">
        <span class="badge badge-pill badge-primary msg_counter bg_red" *ngIf="smcCounter > 0">{{smcCounter}}</span>
        <span title="Secure Message Center" class="p-1 pointer">
          <i class="fas fa-fw fa-envelope fa-lg c_black"></i>
        </span>
      </span>
      <span [routerLink]="'/appinfo'" title="App Info" class="p-1 pointer">
        <i class="fas fa-fw fa-info-circle fa-lg c_black"></i>
      </span>

      <span class="mx-2">|</span>
      <img id="profilePic" [src]="profilePic" title="{{username}}" style="height:30px" *ngIf="profilePic != ''" />
      <span class="copy_brand_sm mx-2">{{ username }}</span>
      <span [routerLink]="'/passkey'" class="pointer c_black mx-2 d-none"><i class="fas fa-fw fa-key mt-1"></i></span>
      <span (click)="logout()" title="Sign Out" class="p-1 pointer c_black">
        <i class="fas fa-fw fa-arrow-right-from-bracket"></i>
      </span>
    </div>
  </div>
</nav>

<div id="ww_sidebar" class="sidebar" [hidden]="!isSidebarOpen">
  <div class="flex-shrink-0 p-2 float-left" style="width:290px;margin-top:0">
    <div class="row">
      <div class="col-6">

      </div>
      <div class="col-6 text-end my-1">
        <span class="pointer c_sand btn_sidebar" (click)="toggleSidebar()" title="Hide Sidebar">
          <i class="fas fa-fw fa-{{ isSidebarOpen ? 'chevron-left' : 'chevron-right' }}"></i>
        </span>
        <span class="pointer c_sand btn_sidebar" (click)="toggleCategories(true)" title="Expand All">
          <i class="fas fa-fw fa-chevron-down" title="Expand All"></i>
        </span>
        <span class="pointer c_sand btn_sidebar" (click)="toggleCategories(false)" title="Collapse All">
          <i class="fas fa-fw fa-chevron-up" title="Collapse All"></i>
        </span>
      </div>
    </div>

    <!-- UNIFIED NAV LIST (CLIENT + ADMIN + USERS ITEMS) -->
    <div class="row mt-4">
      <div class="col-12">
      <!-- CLIENT ITEMS (userRole === 2) -->
        <div class="row" *ngIf="userRole === 2">
          <div class="col-12">
            <ul class="list-unstyled mb-0">
              <li
                  [routerLink]="'/client-dashboard'"
                  class="sidenav_header_lg c_bonedk mb-0">
                <i class="fas fa-chart-line fa-fw fa-lg me-2"></i>Dashboard
              </li>
            </ul>
          </div>
        </div>
        <div class="row" *ngIf="userRole === 2">
          <div class="col-12">
            <ul class="list-unstyled mb-0">
              <li
                  [routerLink]="'/pfs'"
                  class="sidenav_header_lg c_bonedk mb-0">
                <i class="fas fa-link fa-fw fa-lg me-2"></i>PFS
              </li>
            </ul>
          </div>
        </div>
        <div class="row" *ngIf="userRole === 2">
          <div class="col-12">
            <ul class="list-unstyled mb-0">
              <li
                  [routerLink]="'/client-dashboard'"
                  class="sidenav_header_lg c_bonedk mb-0">
                <i class="fa-solid fa-life-ring fa-fw fa-lg me-2"></i>My Lifestyle Requests
              </li>
            </ul>
          </div>
        </div>
        <div class="row" *ngIf="userRole === 2">
          <div class="col-12">
            <ul class="list-unstyled mb-0">
              <li
                  [routerLink]="'/client-dashboard'"
                  class="sidenav_header_lg c_bonedk mb-0">
                <i class="fa-solid fa-money-bill fa-lg me-2"></i>My Bill
              </li>
            </ul>
          </div>
        </div>
        <div class="row" *ngIf="userRole === 2">
          <div class="col-12">
            <ul class="list-unstyled mb-0">
              <li
                  [routerLink]="'/pfs'"
                  class="sidenav_header_lg c_bonedk mb-0">
                <i class="fas fa-link fa-fw fa-lg me-2"></i>Co-Invest Opportunities
              </li>
            </ul>
          </div>
        </div>
        <div class="row" *ngIf="userRole === 2">
          <div class="col-12">
            <ul class="list-unstyled mb-0">
              <li
                  [routerLink]="'/client-files'"
                  class="sidenav_header_lg c_bonedk mb-0">
                <i class="fas fa-folder fa-fw fa-lg me-2"></i>My Client Folder
              </li>
            </ul>
          </div>
        </div>

        <!-- INTERNAL ITEMS (userRole === 1,3) -->
        <div class="row" *ngIf="userRole != 2">
          <div class="col-12">
            <ul class="list-unstyled mb-0">
              <li
                  [routerLink]="'/user-dashboard'"
                  class="sidenav_header_lg c_bonedk mb-0">
                <i class="fas fa-chart-line fa-fw fa-lg me-2"></i>Dashboard
              </li>
            </ul>
          </div>
        </div>
        <div class="row" *ngIf="userRole != 2">
          <div class="col-12">
            <ul class="list-unstyled mb-0">
              <li
                  [routerLink]="'/hourglass'"
                  routerLinkActive="active"
                  class="sidenav_header_lg c_bonedk mb-0">
                <i class="fas fa-hourglass fa-fw fa-lg me-2"></i>Hourglass
              </li>
            </ul>
          </div>
        </div>
        <div class="row" *ngIf="userRole != 2">
          <div class="col-12">
            <ul class="list-unstyled mb-0">
              <li
                  [routerLink]="'/googledriveaccess'"
                  routerLinkActive="active"
                  class="sidenav_header_lg c_bonedk mb-0">
                <i class="fas fa-hard-drive fa-fw fa-lg me-2"></i>File Storage
              </li>
            </ul>
          </div>
        </div>
        <div class="row" *ngIf="userRole === 1">
          <div class="col-12">
            <ul class="list-unstyled mb-0">
              <li
                  [routerLink]="'/trading-dashboard'"
                  class="sidenav_header_lg c_bonedk mb-0">
                <i class="fas fa-tachometer-alt fa-fw fa-lg me-2"></i>Trading Hub
              </li>
            </ul>
          </div>
        </div>
        <div class="row d-none" *ngIf="userRole === 1">
          <div class="col-12">
            <ul class="list-unstyled mb-0">
              <li
                  [routerLink]="'/minutes'"
                  routerLinkActive="active"
                  class="sidenav_header_lg c_bonedk mb-0">
                <i class="fas fa-clock fa-fw fa-lg me-2"></i>MinutesMaker
              </li>
            </ul>
          </div>
        </div>
        <div class="row" *ngIf="userRole != 2">
          <div class="col-12">
            <ul class="list-unstyled mb-0">
              <li
                  [routerLink]="'/academy'"
                  routerLinkActive="active"
                  class="sidenav_header_lg c_bonedk mb-0">
                <i class="fas fa-graduation-cap fa-fw fa-lg me-2"></i>Welara Academy
              </li>
            </ul>
          </div>
        </div>
        <div class="row" *ngIf="userRole === 1">
          <div class="col-12">
            <div class="py-1 mb-1 pointer">
              <div (click)="toggleSubnav()" class="sidenav_header c_black mb-0">
                <div class="row">
                  <div class="col-9"><i class="fas fa-lock fa-fw fa-lg ms-3 me-2"></i>Admin Tools</div>
                  <div class="col-3 text-end">
                    <div class="p-1 pointer">
                      <i class="fas fa-fw ms-2 text-end"
                         [ngClass]="(isSubnavAdminOpen) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </div>
          </div>
        <!-- Admin tools subnav -->
        <div class="row" *ngIf="userRole === 1 && isSubnavAdminOpen">
          <div class="col-12 ps-5">
            <ul class="list-unstyled mb-0">
              <!--<li [routerLink]="'/billingreview'" routerLinkActive="active" class="sidenav_header_lg c_bonedk mb-0">
                <i class="fa-solid fa-magnifying-glass fa-fw fa-lg me-2"></i>Billing Review Grid
              </li>-->
              <li [routerLink]="'/admin/billing-review-pivot-grid'" routerLinkActive="active"
                  class="sidenav_header_lg c_bonedk mb-0">
                <i class="fa-solid fa-magnifying-glass-dollar fa-fw fa-lg me-2"></i>Billing Review Pivot Grid
              </li>
              <li [routerLink]="'/taskcombine'" routerLinkActive="active" class="sidenav_header_lg c_bonedk mb-0">
                <i class="fa-solid fa-code-merge fa-fw fa-lg me-2"></i>Task Combinator
              </li>
              <li [routerLink]="'/teams'" routerLinkActive="active" class="sidenav_header_lg c_bonedk mb-0">
                <i class="fa-solid fa-people-group fa-fw fa-lg me-2"></i>Teams Tool
              </li>
              <li [routerLink]="'/excel-upload'" class="sidenav_header_lg c_bonedk mb-0">
                <i class="fas fa-chart-line fa-fw fa-lg me-2"></i>Excel Upload
              </li>
              <li [routerLink]="'/btcprice'" class="sidenav_header_lg c_bonedk mb-0 d-none">
                <i class="fas fa-coins fa-fw fa-lg me-2"></i>Crypto Price Widget
              </li>
              <li [routerLink]="'/admin/dynamicsqladder'" class="sidenav_header_lg c_bonedk mb-0">
                <i class="fas fa-chart-line fa-fw fa-lg me-2"></i>Dynamic SQL Field Manager
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- DYNAMIC GROUPED MENU (ADMIN ONLY, LEFT UNCHANGED) -->
    <div class="row" *ngIf="userRole === 1">
      <div class="col-12">
        <div *ngFor="let categoryId of getCategoryIds()" class="py-1 mb-1 pointer">
          <div class="c_black sidenav_header" data-bs-toggle="collapse"
            attr.data-bs-target="#sub{{ categoryId }}-collapse" aria-expanded="true">
            <div class="row">
              <div class="col-9">
                <i class="{{groupedMenuItems[categoryId].categoryIcon}} fa-fw fa-lg ms-3 me-2"></i>{{
                groupedMenuItems[categoryId].categoryName }}
              </div>
              <div class="col-3 text-end">
                <div class="p-1 pointer">
                  <i class="fas fa-fw fa-chevron-down"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="collapse" id="sub{{ categoryId }}-collapse">
            <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
              <li *ngFor="let menuItem of groupedMenuItems[categoryId].items" [routerLink]="menuItem.router_link"
                routerLinkActive="active" class="c_dktrey">
                <i class="{{ menuItem.menu_item_icon_data }} fa-fw me-2"></i>{{ menuItem.menu_item_name }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

<div id="ww_main" class="main-content" [ngClass]="isSidebarOpen ? 'sidenav_on' : 'sidenav_off'">
  <router-outlet></router-outlet>
</div>

<div class="session-warning-backdrop" *ngIf="showSessionWarningModal">
    <div class="card">
      <div class="card-header">
        <h4><i class="fas fa-fw fa-hourglass me-2"></i>Inactivity Warning</h4>
      </div>
      <div class="card-body" style="font: 500 12pt FuturaPTBook !important">
        <div>
          You will be logged out in <strong>{{ formatSeconds(warningSecondsRemaining) }}</strong> due to inactivity.
        </div>
        <div class="mt-2">
          To continue, click <strong><i class="fas fa-fw fa-hourglass-start me-1"></i>Extend Session</strong>.
        </div>
      </div>
      <div class="card-footer">
        <button type="button" (click)="extendSession()" class="btn btn-sm btn-dark me-2">
          <i class="fas fa-fw fa-hourglass-start me-1"></i>Extend Session
        </button>
        <button type="button" (click)="logoutFromWarning()" class="btn btn-sm btn-dark">
          <i class="fas fa-fw fa-sign-out-alt me-1"></i>Log out
        </button>
      </div>
    </div>
</div>

